import { render, staticRenderFns } from "./TheProductList.vue?vue&type=template&id=73c04108&scoped=true&"
import script from "./TheProductList.vue?vue&type=script&lang=js&"
export * from "./TheProductList.vue?vue&type=script&lang=js&"
import style0 from "./TheProductList.vue?vue&type=style&index=0&id=73c04108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c04108",
  null
  
)

export default component.exports